export class OrganizationStudentSearchItemFieldModel {
	title?: string;
	order: boolean;
	filter: boolean;
}

export function OrganizationStudentSearchItemFieldModel_ClassTransform_Type() {
	return OrganizationStudentSearchItemFieldModel;
}
